@if (progressBar()) {
  <aw-ticket-configuration-progress-tracker
    [backLink]="ERoute.subscriptions"
    [progressBarContent]="
      progressBar()
    "></aw-ticket-configuration-progress-tracker>
  <div class="container mx-auto pb-4">
    <router-outlet></router-outlet>
  </div>
}
